import { useAtom } from "jotai";
import { useMemo } from "react";
import type { Pog } from "@CommonTypes/merchflow/pog/pog";
import { getActiveShelfDividers } from "@CommonUtils/pog/shelfDividers";
import { planogramShowDividersAtom } from "src/components/PlanogramExtensions/store/atoms";

export const pogHasShelfDividers = (pog: Pog | null | undefined) =>
  pog?.planogram.bays.some((bay) =>
    bay.shelves.some((shelf) => getActiveShelfDividers(shelf.dividers) !== null),
  ) ?? false;

/** Whether dividers are drawn: the user's toggle, else on exactly when the pog has any. */
export const useShowDividers = (pog: Pog | null | undefined) => {
  const [choice, setShowDividers] = useAtom(planogramShowDividersAtom);
  const hasDividers = useMemo(() => pogHasShelfDividers(pog), [pog]);
  return { hasDividers, setShowDividers, showDividers: choice ?? hasDividers };
};
